const topMain = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let sec = document.querySelector('#jsSecMain');
    let mainWrap = sec.querySelector('.js-main-wrap');
    let bgBox = mainWrap.querySelector('.js-bg-box');
    let replay = bgBox.querySelector('.js-replay');

    let video
    let sW = window.innerWidth;
    if (sW > 768) {
      video = bgBox.querySelector('.js-video-pc');
    } else {
      video = bgBox.querySelector('.js-video-sp');
    }

    const videoFrame = () => {
      let time = video.currentTime
      // console.log(time);
      if (time > 13) {
        replay.classList.add('is-act');
      }
      window.requestAnimationFrame(videoFrame);
    }
    window.requestAnimationFrame(videoFrame);


    replay.addEventListener('click', () => {
      replay.classList.remove('is-act');
      video.currentTime = 0;
      video.play();
    });



  }
})()
export default topMain;